export default __webpack_public_path__ + "static/media/cooldude.9c3160c0.svg";